import type { ComponentProps, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icon, Tooltip } from '~/components';
import type { TooltipProps } from '~/components/Tooltip';

export interface FilterTagTooltipProps {
  tooltip?: Partial<TooltipProps>;
  trans: Partial<ComponentProps<typeof Trans>>;
  children?: ReactNode;
  translationNamespace?: string;
}

// @TODO WMG1-678 - Move to shared location for roster and user management.
export function FilterTagTooltip({
  tooltip,
  trans,
  children,
  translationNamespace = 'roster',
}: FilterTagTooltipProps) {
  const { t } = useTranslation(translationNamespace);

  return (
    <Tooltip
      triggerAsChild
      content={
        <div className="max-w-[300px] leading-4">
          <Trans
            {...{
              t,
              components: { br: <br /> },
              ...trans,
            }}
          />
        </div>
      }
      size="sm"
      align="start"
      sideOffset={4}
      {...tooltip}
    >
      {children ?? (
        <div>
          <Icon type="circle-info" variant="light" size="md" />
        </div>
      )}
    </Tooltip>
  );
}

FilterTagTooltip.displayName = 'FilterTagTooltip';
